import gql from 'graphql-tag'

export const eligibilityDelete = gql`
  mutation eligibilityDelete($name: NonEmptyString!) {
    eligibilityDelete(input: { name: $name }) {
      success
    }
  }
`
